
<template>
  <div class="assess">
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text=""
      @load="onLoad"
    >
      <!-- 1111 -->
      <div v-for="(item, index) in list" v-show="list.length>0" :key="index" class="assess-msg">
        <div class="nick">
          <div class="nick-img">
            <img onerror="javascript:this.src='https://newoss.zhulong.com/tfs/noavatar_big.gif'" :src="item.avatar" alt>
          </div>
          <div id="nick" class="nick-name">
            <p>
              <span>{{ item.username }}</span>
              <span style="color: #999;float:right;">{{ sli(item.create_time) }}</span>
            </p>

            <van-rate
              v-model="item.rank"
              color="#ffd21e"
              style="margin-top: 5px"
              :count="5"
              size="15"
              readonly
            />
            <p id="p" style="padding-top: 5px;fontSize:15px" v-html="item.content.replace(/<img.*?>/g, '')"></p>
            <div v-if="item.reply" class="hfP">
              <div class="hfPTop">
                <img src="@/assets/myicon/techer.png" alt="">
                <span class="teacher">老师:</span>
              </div>
              <span class="t_content">
                {{ item.reply.content }}
              </span>
            </div>
          </div>
        </div>
      <!-- <div class="nick-data">

      </div> -->
      </div>
    </van-list>
    <div v-show="list.length<=0" class="kongzt">
      <img src="@/assets/new_kong.png" alt>
      <p>暂无评价～</p>
    </div>
  </div>
</template>
<script>
/*
 *  date:2021/6/15
 *  authour:li yao
 *  describe:评价组件
 */
import { get_evaluate } from '@/api/course.js'
export default {
  name: 'Assess',
  data() {
    return {
      value: 1,
      page: 1,
      list: [
        // {
        //   attr: [],
        //   avatar: 'http://avatar.zhulong.com/avatar/015/61/46/56_avatar_small.jpg',
        //   content: '大学学习的是工程管理，现在在一家国企做成本管理岗，但一直未自己动手算量或者套价一个完整的项目，都是委托的第三方咨询单位，希望通过三个月的学习，能提升动手能力，能熟练掌握识图、算量、组价，这样跟施工单位谈判也更有底气，而不是完全依靠第三方机构。',
        //   create_time: '2021-07-26 09:53:53',
        //   id: 2898028,
        //   rank: 5,
        //   reply: {
        //     content: '相信你，没有问题的',
        //     create_time: '2021-07-26 09:53:53',
        //     id: 2898029,
        //     parent_id: 2898028,
        //     username: '龙友15614656'
        //   },
        //   uid: 15614656,
        //   username: '龙友15614656'
        // },
        // {
        //   attr: [],
        //   avatar: 'http://avatar.zhulong.com/avatar/015/61/46/56_avatar_small.jpg',
        //   content: '大学学习的是工程管理，现在在一家国企做成本管理岗，但一直未自己动手算量或者套价一个完整的项目，都是委托的第三方咨询单位，希望通过三个月的学习，能提升动手能力，能熟练掌握识图、算量、组价，这样跟施工单位谈判也更有底气，而不是完全依靠第三方机构。',
        //   create_time: '2021-07-26 09:53:53',
        //   id: 2898028,
        //   rank: 5,
        //   reply: {
        //     content: '相信你，没有问题的',
        //     create_time: '2021-07-26 09:53:53',
        //     id: 2898029,
        //     parent_id: 2898028,
        //     username: '龙友15614656'
        //   },
        //   uid: 15614656,
        //   username: '龙友15614656'
        // },
        // {
        //   attr: [],
        //   avatar: 'http://avatar.zhulong.com/avatar/015/61/46/56_avatar_small.jpg',
        //   content: '大学学习的是工程管理，现在在一家国企做成本管理岗，但一直未自己动手算量或者套价一个完整的项目，都是委托的第三方咨询单位，希望通过三个月的学习，能提升动手能力，能熟练掌握识图、算量、组价，这样跟施工单位谈判也更有底气，而不是完全依靠第三方机构。',
        //   create_time: '2021-07-26 09:53:53',
        //   id: 2898028,
        //   rank: 5,
        //   reply: {
        //     content: '相信你，没有问题的',
        //     create_time: '2021-07-26 09:53:53',
        //     id: 2898029,
        //     parent_id: 2898028,
        //     username: '龙友15614656'
        //   },
        //   uid: 15614656,
        //   username: '龙友15614656'
        // }
      ],
      total: 0,
      retlen: 0,
      limit: 6,
      loading: false,
      finished: false
    }
  },
  mounted() {
    // this.getEvaluate()
  },
  methods: {
    // slice
    sli(v) {
      var s = String(v).slice(0, 10)
      return s
    },
    // 评价列表
    onLoad() {
      if (!this.finished){
        var params = {
          page: this.page,
          limit: this.limit,
          lesson_id: this.$route.query.lesson_id
        }
        get_evaluate(params).then((res) => {
          // this.list = res.result.list
          // console.log(res.result, '888888999999')
          if (this.list.length >= 6 || this.list.length == 0) {
            this.list = this.list.concat(res.result.list)
            this.total = res.result.count // 数据总条数
            this.retlen = res.result.list.length // 本次返回数据的长度
            if (this.retlen < this.limit) {
              console.log(321)
              this.finished = true // 数据加载完毕显示 没有更多了
              this.isShow = true
            } else {
              this.page += 1
            }
            this.loading = false
            console.log(this.list)
          }
        })
      }
    },
    // getEvaluate() {
    //   var params = {
    //     lesson_id: this.$route.query.lesson_id
    //   }
    //   get_evaluate(params)
    //     .then((res) => {
    //       if (res.result.list !== undefined) {
    //         this.list = res.result.list
    //       }
    //       this.num = res.result.count
    //     })
    //     .then(() => {
    //       this.send()
    //     })
    // },
    send() {
      this.$emit('getMsg', this.num)
    }
  }
}
</script>
<style scoped lang="scss">
.hfP{
  width: 94%;
  background-color: #f6f6f6;
  // height: 50px;
  min-height: 40px;
  padding: 8px;
  display: flex;
  align-items: center;
  margin-top: 30px;
  .hfPTop {
    width: 125px;
    height: 100%;
    display: flex;
    img {
      margin-left: 10px;
      margin-top: 1px;
      width: 30px !important;
      height: 30px !important;
    }
    .teacher {
      margin-left: 10px;
      height: 40px;
      line-height: 40px;
      width: 75px;
      color: #ee2e2e;
    }
  }
  .t_content {
    width: calc(100% - 130px);
    margin-left: 5px;
    color: #333;
    text-align: left;
  }
}
.kongzt {
  width: 100%;
  img {
    width: 310px;
    height: 310px;
    margin: 0 auto;
    display: block;
    margin-top: 300px;
    margin-bottom: 50px;
  }
  p {
    font-size: 30px;
    // font-weight: 600;
    padding-bottom: 20px;
    color: #999;
    text-align: center;
    padding-top: 30px;
  }
}
.assess {
  margin: 23px 21px 200px 19px;
  font-size: 26px;
  .assess-msg {
    width:100%;
    margin-top: 20px;
    border-bottom: #f8f8f8 2px solid;
    min-height: 185px;
    display: flex;
    justify-content: space-between;
    .nick {
      padding:0 13px 20px;
      width: 100%;
      display: flex;
      .nick-img {
        width: 80px;
        height: 80px;
        img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
      }

      .nick-name {
        display: flex;
        flex-direction: column;
        margin-left: 11px;
        width: 88%;
        font-size: 28px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>
<style>
#nick >>> img {
  width: 20px;
  height: 20px;
}
</style>
